import React from "react";
import { Link } from "gatsby";
import edReactURLFilter from "ed-react-url-filter";
import styles from "./styles/PostExcerpt.module.scss";
import {PostMetaComponent} from "./PostMeta.jsx";
import RetinaImage from  "react-retina-image";

export default function({post}) {

  var linkElement = document.createElement('a');
  linkElement.href = post.link
	let link = linkElement.pathname;

	let title =  post.title;
	let date = post.date;
	let author = post.author.name;
	let content = post.content
	let mediaURLx1= post.mediaURLx1;
	let mediaURLx2= post.mediaURLx2;

  let morePos = content.indexOf("<!--more-->"); //return -1 if null
	let myExcerpt = morePos !== -1 ? content.substring(0,morePos) : post.excerpt;

	return (

		<div className="post-excerpt">

			<Link to={link}>
				<h2 className={styles.Title} dangerouslySetInnerHTML={{__html:title}} />
			</Link>
			<PostMetaComponent date={date} author={author} />

			<Link to={link}>
				<RetinaImage src={[mediaURLx1, mediaURLx2]} checkIfRetinaImgExists={true} className="img-responsive featured-image col-xs-12" forceOriginalDimensions={false} />
			</Link>

			<div className={styles.Exerpt} dangerouslySetInnerHTML={{__html: myExcerpt}} />

			<p className={styles.Readmore}>
				<Link to={link}>
					read more
				</Link>
			</p>

		</div>

	);
}
